'use client';

import React, { useState, useRef, useEffect } from 'react';
import Slider from 'react-slick';
import Image from 'next/image';
import PropTypes from 'prop-types';
import styles from './TeamCarousel.module.css';
import '@/app/main.css';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// ✅ Custom Arrows
function PrevArrow({ className, onClick, style }) {
  return (
    <div
      className={className}
      style={{ ...style, display: 'block', left: '-20px', zIndex: 1, bottom: '-90px' }}
      onClick={onClick}
    >
      ←
    </div>
  );
}

function NextArrow({ className, onClick, style }) {
  return (
    <div
      className={className}
      style={{ ...style, display: 'block', right: '-20px', zIndex: 1, bottom: '-90px' }}
      onClick={onClick}
    >
      →
    </div>
  );
}

// ✅ Team Member Data
const teamMembers = [
  {
    img: '/bulkyMall.svg',
    name: 'Pintu',
    role: 'Bulky Mall',
    testimonial:"I recently had the pleasure of working with Eratec Solution and couldn't be more impressed with their service and expertise. From the initial consultation  to the final implementation, their team displayed exceptional professionalism and a deep understanding of our needs.",
  },
  { img: '/orientalTrimexLogo.svg', name: 'Truna', role: 'Oriental Trimex ltd', testimonial: "Incredible work done by the Team. Especially Anita ji, she’s always hands-on for any additions & amendments as per our requirement. Moreover, she never hesitates to share her valuable suggestions that’s favourable for our comapany’s profile. I’m grateful to have an association with this team.Thanks & best wishes!" },
  { img: '/manojit.svg', name: 'Manojit Singh', role: 'CEO', testimonial: "Ability to grasp . Adhere to time line and immense patience is hallmark of the company . Looking forward for more collaborations with them ." },
  { img: '/packersMovers.svg', name: 'Amit Kashyap', role: 'Friends Packers And Movers', testimonial: "Eratech Solution delivered an outstanding website for our moving business—fast, user-friendly, and perfectly aligned with our brand. Their development team provided seamless communication and expert technical execution. Highly recommend their digital solutions!" },
  { img: '/ThatHardwareStoreLogo.svg', name: 'Rajat Bhushan', role: 'That Hardware Store', testimonial: "Eratec Solution did a great job on our website. It works perfectly, looks professional, and helped grow our business.Their team was professional, understood our needs perfectly, and delivered on time.Highly recommended!" },
];

export default function TeamCarousel({ windowSize = 5 }) {
  const [activeSlide, setActiveSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const sliderRef = useRef(null);
  const total = teamMembers.length;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const visibleDots = isMobile ? 3 : windowSize;
  const centerIndex = Math.floor(visibleDots / 2);

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    beforeChange: (_, next) => setActiveSlide(next),
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    customPaging: () => <div style={{ display: 'none' }} />,
    appendDots: () => {
      const indices = Array.from({ length: visibleDots }, (_, idx) =>
        (activeSlide - centerIndex + idx + total) % total
      );

      return (
        <div className={styles.thumbnailWrapper.carousel}>
          <div className={styles.thumbnailScroller}>
            <ul className={`slick-dots ${styles.slickThumbs}`} role="list">
              {indices.map((i, idx) => {
                const classNames = [
                  styles.customDot,
                  i === activeSlide && styles.activeDot,
                  idx === centerIndex - 1 && styles.prevDot,
                  idx === centerIndex + 1 && styles.nextDot,
                ].filter(Boolean).join(' ');

                return (
                  <li
                    key={i}
                    className={classNames}
                    onClick={() => sliderRef.current.slickGoTo(i)}
                    role="listitem"
                  >
                    <Image
                      src={teamMembers[i].img}
                      alt={`View ${teamMembers[i].name}'s profile`}
                      width={60}
                      height={60}
                      priority={i === activeSlide}
                    />
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      );
    },
  };

  return (
    <div className="works-area pt-50  bg-#FFFFFF00">
      <div className="container">
        <div
          className={styles.teamCarouselContainer}
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-duration="500"
          data-aos-once="true"
        >
         { /*<Slider ref={sliderRef} {...settings}>
            {teamMembers.map((member, idx) => (
              <div key={idx}>
                <div
                  className={styles.teamCard}
                  style={{
                    display: idx === activeSlide ? 'block' : 'none',
                    opacity: idx === activeSlide ? 1 : 0,
                    transition: 'opacity 0.5s ease',
                  }}
                >
                  <div className={styles.testimonialContent}>
                    <div className={styles.clientImage}>
                      <Image
                        src={member.img}
                        alt={`${member.name}'s portrait`}
                        width={120}
                        height={120}
                        priority={idx === 0}
                      />
                    </div>
                    <div className={styles.testimonialText}>
                      <h3>{member.name}</h3>
                      <span className={styles.memberRole}>{member.role}</span>
                      <p>{member.testimonial}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>*/}
           <Slider ref={sliderRef} {...settings}>
              {teamMembers.map((member, idx) => (
                  <div key={idx}>
                    <div className={styles.teamCard} style={{ 
                      display: idx === activeSlide ? 'block' : 'none',
                      opacity: idx === activeSlide ? 1 : 0,
                      transition: 'opacity 0.5s ease'
                    }} data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                      <div className={styles.testimonialContent}>
                        <div className={styles.clientImage}>
                          <Image
                            src={member.img}
                            alt={`${member.name}'s portrait`}
                            width={120}
                            height={120}
                            priority={idx === 0}
                          />
                        </div>
                        <div className={styles.testimonialText}>
                          <h3>{member.name}</h3>
                          <span className={styles.memberRole}>{member.role}</span>
                          <p>{member.testimonial}</p>
                          {member.readMoreLink && (
                            <a href={member.readMoreLink} className={styles.readMoreLink} target="_blank">
                              Read more
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
           </Slider>
 
        </div>
      </div>
    </div>
  );
}

TeamCarousel.propTypes = {
  windowSize: PropTypes.number,
};
